import { render, staticRenderFns } from "./TabsDashboardProfile.vue?vue&type=template&id=7ffc20e5&"
import script from "./TabsDashboardProfile.vue?vue&type=script&lang=js&"
export * from "./TabsDashboardProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports